<div class="app">
  <div class="app__header" #appHeader>
    <tiss-starting-price-banner />

    @if (!isTurkishBuild()) {
      <tiss-page-header dataAttribute componentName="header" />
    }

    @if (turkishHeaderComponent(); as headerComponent) {
      <ng-container *ngComponentOutlet="headerComponent" />
    }
  </div>

  <div
    class="page-body"
    [class.page-body--turkish-build]="isTurkishBuild()"
    [class.page-body--compact-header]="isCompactHeaderVisible()"
    [attr.data-compact-header]="isCompactHeaderVisible()"
  >
    <div class="content-wrapper" [class.content-wrapper__narrow]="isNarrowLayout()">
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <b2b-portal-footer dataAttribute componentName="footer" />
</div>

@if (!isTurkishBuild()) {
  <b2b-navigation-mobile-menu
    *showOnPlatformNarrow="[Platform.Mobile, Platform.Tablet]"
    dataAttribute
    componentName="navigation-mobile-menu"
  />
} @else {
  <b2b-navigation-mobile-menu
    *showOnPlatform="Platform.Mobile"
    dataAttribute
    componentName="navigation-mobile-menu"
  />
}

<ng-container *showOnPlatform="Platform.Desktop">
  @if (chatBotComponent(); as chatBotComponent) {
    <ng-container *ngComponentOutlet="chatBotComponent" />
  }
</ng-container>
